import warehouseIcon from "../../../assets/images/warehouse.svg";
import preflightIcon from "../../../assets/images/preflight.svg";

import postFlightIcon from "../../../assets/images/flight_land.svg";
import deliveryIcon from "../../../assets/images/delivery.svg";
import monitoringIcon from "../../../assets/images/language.svg";
export const alertThresholdsConfig = [
  {
    category: "Pre-pick",
    icon: warehouseIcon,
    rules: [
      {
        id: "low_battery_at_origin",
        title: "Low battery at origin",
        description:
          "When a shipment’s sensor battery is below the set threshold at origin",
        conditionType: "Under",
        unit: "%",
        min: 0,
        max: 100,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: true,
        showSetupSensorIcon: false,
        showResetIcon: true,
      },
      // {
      //   id: "ignore_sensor_measurement_period",
      //   title: "Ignore sensor measurement period at start",
      //   description:
      //     "To avoid false alarms during shipment packing, define a time buffer in which sensor measurements will be ignored",
      //   conditionType: "Under",
      //   unit: "mins",
      //   min: 0,
      //   max: 120,
      //   showSensorInfoIcon: false,
      //   showSensorInfoIconDisabled: true,
      //   showSetupSensorIcon: false,
      //   showResetIcon: true,
      // },
    ],
  },
  {
    category: "Pre-flight",
    icon: preflightIcon,
    rules: [
      {
        id: "driver_late_to_pickup",
        title: "Driver late to pick-up",
        description:
          "When a driver missed the expected pick-up time by a certain amount of time",
        conditionType: "Over",
        unit: "mins",
        min: 0,
        max: 120,
        showInfoIcon: false,
        showResetIcon: false,
        showResetIcon: true,
      },
      {
        id: "flight_delayed_beyond_threshold",
        title: "Flight delayed beyond threshold time",
        description:
          "When a flight has been delayed beyond a specified duration",
        conditionType: "Over",
        unit: "mins",
        min: 0,
        max: 120,
        showInfoIcon: false,
        showResetIcon: false,
        showResetIcon: true,
      },
      {
        id: "shipment_not_loaded_onto_flight",
        title: "Shipment not loaded onto flight",
        description:
          "When the shipment’s location data and flight’s location data diverge for longer than the set period, indicating the shipment likely wasn’t loaded onto the plane",
        conditionType: "Over",
        unit: "mins",
        min: 0,
        max: 120,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: true,
        showSetupSensorIcon: false,
        showResetIcon: true,
      },
    ],
  },
  {
    category: "Post-flight",
    icon: postFlightIcon,
    rules: [
      {
        id: "offload_delay_after_flight_arrival",
        title: "Offload delay after flight arrival",
        description:
          "When unloading the shipment from a flight takes longer than expected",
        conditionType: "Over",
        unit: "mins",
        min: 0,
        max: 120,
        sensorNote: "(Sensor optional)",
        showResetIcon: true,
      },
      {
        id: "driver_late_to_recover_shipment",
        title: "Driver late to recover shipment",
        description:
          "When the shipment is taking longer than expected to get picked up by a driver after offboarding confirmation",
        conditionType: "Over",
        unit: "mins",
        min: 0,
        max: 120,
        showResetIcon: true,
      },
    ],
  },
  {
    category: "At delivery",
    icon: deliveryIcon,
    rules: [
      {
        id: "driver_cant_find_location",
        title: "Driver can’t find location",
        description:
          "When a driver reaches the destination vicinity but hasn’t completed the delivery within the expected time",
        conditionType: "Over",
        unit: "mins",
        min: 0,
        max: 120,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: true,
        showSetupSensorIcon: false,
        showResetIcon: true,
      },
      {
        id: "delivered_to_wrong_address",
        title: "Delivered to the wrong address",
        description:
          "When delivery location deviates from address on file by more than the allowed distance",
        conditionType: "Over",
        unit: "ft",
        min: 100,
        max: 2000,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: false,
        showSetupSensorIcon: false,
        sensorNote: "(Sensor optional)",
        showResetIcon: true,
      },
      {
        id: "delivered_to_wrong_recipient",
        title: "Delivered to wrong recipient",
        description:
          "When the name on the proof of delivery (POD) does not match the intended recipient’s name on file",
        conditionType: null,
        unit: "",
        min: 0,
        max: 999,
        showResetIcon: true,
      },
    ],
  },
  {
    category: "Continuous monitoring",
    icon: monitoringIcon,
    rules: [
      {
        id: "low_battery",
        title: "Low battery",
        description:
          "When a sensor’s battery level drops below the defined threshold",
        conditionType: "Below",
        unit: "%",
        min: 0,
        max: 100,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: true,
        showSetupSensorIcon: false,
        showResetIcon: true,
      },
      {
        id: "flight_landing_close_to_cargo_closing_time",
        title: "Flight landing close to cargo closing time",
        description:
          "When a Flight’s expected arrival time is too close to cargo closing hours at the recovery airport",
        conditionType: "Under",
        unit: "mins",
        min: 0,
        max: 120,
        showResetIcon: true,
      },
      {
        id: "weather_event_impact_expected",
        title: "Weather event impact expected",
        description:
          "When the shipment is expected to cross a weather event of a certain severity, defined on a scale of 1-5, with Level 1 having minimal impact, Level 5 having extreme/catastrophic impact. Re-routing decisions typically implemented starting Level 3",
        conditionType: "From",
        unit: "Level",
        min: 1,
        max: 5,
        showResetIcon: true,
      },
      {
        id: "status_update_overdue",
        title: "Status Update Overdue",
        description:
          "When the time elapsed without a status update exceeds a multiple of the historical median, flagging unexpected delays (min 10 shipments baseline required).",
        conditionType: "Over",
        unit: "X",
        min: 1,
        max: 999,
        showResetIcon: true,
      },
      {
        id: "vehicle_idle_in_transit",
        title: "Vehicle idle in transit",
        description:
          "When a vehicle has remained idle for a certain amount of time while in transit",
        conditionType: "Over",
        unit: "mins",
        min: 0,
        max: 120,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: true,
        showSetupSensorIcon: false,
        showResetIcon: true,
      },
      {
        id: "temperature_nearing_limit",
        title: "Temperature nearing limit",
        description:
          "When the shipment’s temperature is within the defined margin of its allowable range, indicating it’s nearing an excursion threshold",
        conditionType: "Within",
        unit: "%",
        min: 0,
        max: 100,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: true,
        showSetupSensorIcon: false,
        showResetIcon: true,
      },
      {
        id: "temperature_excursion_detected",
        title: "Temperature excursion detected",
        description:
          "When the shipment’s temperature goes outside its allowable range for longer than the specified duration",
        conditionType: "Over",
        unit: "mins",
        min: 0,
        max: 120,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: true,
        showSetupSensorIcon: true,
        showResetIcon: true,
      },
      {
        id: "viability_window_risk_expiring",
        title: "Viability window at risk of expiring before delivery",
        description:
          "When a Product viability window is too close to the anticipated transit time left",
        conditionType: "Within",
        unit: "mins",
        min: 0,
        max: 120,
        showResetIcon: true,
      },
      {
        id: "viability_window_nearly_exhausted",
        title: "Viability window nearly exhausted",
        description:
          "When the shipment’s remaining viability time is close to being exhausted, signaling an imminent risk to product stability",
        conditionType: "Under",
        unit: "mins",
        min: 0,
        max: 120,
        showResetIcon: true,
      },
      {
        id: "viability_window_exhausted",
        title: "Viability window exhausted",
        description:
          "When the shipment’s viability time is exhausted for longer than the specified duration",
        conditionType: "Over",
        unit: "mins",
        min: 0,
        max: 120,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: false,
        showSetupSensorIcon: true,
        showResetIcon: true,
      },
      {
        id: "excessive_light_exposure_detected",
        title: "Excessive Light exposure detected",
        description:
          "When the shipment’s light exposure goes beyond its allowable maximum value for longer than the specified duration",
        conditionType: "Over",
        unit: "mins",
        min: 0,
        max: 120,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: true,
        showSetupSensorIcon: false,
        showResetIcon: true,
      },
      {
        id: "excessive_tilt_detected",
        title: "Excessive tilt detected",
        description:
          "When the shipment has been titled beyond its maximum value for longer than the specified duration",
        conditionType: "Over",
        unit: "mins",
        min: 0,
        max: 120,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: true,
        showSetupSensorIcon: false,
        showResetIcon: true,
      },
      {
        id: "excessive_pressure_detected",
        title: "Excessive pressure detected",
        description:
          "When the shipment’s pressure goes outside its allowable range for longer than the specified duration",
        conditionType: "Over",
        unit: "mins",
        min: 0,
        max: 120,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: true,
        showSetupSensorIcon: false,
        showResetIcon: true,
      },
      {
        id: "excessive_humidity_detected",
        title: "Excessive humidity detected",
        description:
          "When the shipment’s humidity goes outside its allowable range for longer than the specified duration",
        conditionType: "Over",
        unit: "mins",
        min: 0,
        max: 120,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: true,
        showSetupSensorIcon: false,
        showResetIcon: true,
      },
      {
        id: "excessive_shock_detected",
        title: "Excessive shock detected",
        description:
          "When a sensor detects an impact or shock that exceeds the configured shock threshold we will notify your right away",
        conditionType: null,
        unit: "",
        min: 0,
        max: 999,
        showSensorInfoIcon: false,
        showSensorInfoIconDisabled: true,
        showSetupSensorIcon: false,
        showResetIcon: true,
      },
    ],
  },
];
